import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
export var name = 'navigation';

var NavigationModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(NavigationModule, _VuexModule);

  var _super = _createSuper(NavigationModule);

  function NavigationModule() {
    var _this;

    _classCallCheck(this, NavigationModule);

    _this = _super.apply(this, arguments);
    _this.navigationTree = [{
      title: 'Dashboard',
      url: '/dashboard'
    },
    /*{
     title: 'Meine Events',
     url: '/events',
     children: [
       {
         title: 'Events erstellen',
         url: '/events/create'
       },
       {
         title: 'Aktuelle Events',
         url: '/events/'
       }
     ]
    },*/
    {
      title: 'Mein Konto',
      url: '/wizard'
    }, {
      title: 'Logout',
      url: '/logout'
    }, {
      adminOnly: true,
      title: 'Admin',
      url: '/adminDashboard'
    }];
    _this.count = 0;
    return _this;
  }

  _createClass(NavigationModule, [{
    key: "increment",
    value: function increment(delta) {
      this.count += delta;
    }
  }, {
    key: "setTest",
    value: function setTest(delta) {
      this.increment(delta); //this.context.commit('increment', delta)
    }
  }, {
    key: "sitemap",
    get: function get() {
      return this.navigationTree;
    }
  }]);

  return NavigationModule;
}(VuexModule);

__decorate([Mutation], NavigationModule.prototype, "increment", null);

__decorate([Action({})], NavigationModule.prototype, "setTest", null);

NavigationModule = __decorate([Module({
  namespaced: true,
  name: 'navigation',
  stateFactory: true
})], NavigationModule);
export default NavigationModule;